import { Link } from 'react-router';

import { NavMenu } from './NavMenu';

/**
 * Footer links to the legal pages (paths kept here so the page content stays out of the main bundle).
 */
const LEGAL_LINKS = [
    { to: '/legal/terms', label: 'Terms · Conditions' },
    { to: '/legal/privacy', label: 'Privacy · Confidentialité' },
    { to: '/legal/disclaimer', label: 'Disclaimer · Avertissement' },
    { to: '/legal/sources', label: 'Sources' },
];

/**
 * Page frame: the slate top band, the page, and a mono footer with the disclaimer and the legal links.
 */
export const Layout = ({ children }) => {
    return (
        <div className="flex min-h-screen flex-col">
            <NavMenu />
            <main role="main" className="flex-1 pb-20">
                {children}
            </main>
            <footer className="mt-[100px] px-4 md:px-8">
                <div className="mono mx-auto max-w-[1400px] border-t border-ink py-5 text-ink-2">
                    <p className="mb-1">For information only, not investment advice. Data may contain errors.</p>
                    <p lang="fr" className="mb-4">À titre informatif seulement, pas des conseils en placement. Les données peuvent contenir des erreurs.</p>
                    <div className="flex flex-wrap justify-between gap-2">
                        <nav aria-label="Legal" className="flex flex-wrap gap-x-4 gap-y-1">
                            {LEGAL_LINKS.map((l) => <Link key={l.to} to={l.to} className="text-ink-2">{l.label}</Link>)}
                        </nav>
                        <span>&copy; 2021-{new Date().getFullYear()} NewStatements.com</span>
                    </div>
                </div>
            </footer>
        </div>
    );
}
